// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26DYo","question":"styles_question__16YEY","inputVisibleButton":"styles_inputVisibleButton__XYBie","note":"styles_note__2lZDJ"};